import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import { Table } from '../../../../components/Table'
import Button from '../../../../components/components-ui/Button/Button'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/Api'
import Loading from '../../../../components/components-ui/Loading/Loading'

export default function Bombona() {
  const [listaBombona, setListaBombona] = useState([])
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    async function getBombona() {
      setShowLoading(true)
      const response = await api.get('/bombona/index')
      setListaBombona(response.data)
      setShowLoading(false)
    }
    getBombona()
  }, [])

  // Colunas da tabela
  const columns = [
    {
      column: 'Bombona',
    },
  ]

  return (
    <Container>
      <h3>Listagem de Bombona</h3>
      <Link to="/usina/bombona/novo/">
        <Button title="Novo" type="button" />
      </Link>

      <div className={styles.content}>
        <Table edit columns={columns}>
          {listaBombona.map(({ IdBombonas, bombona }) => (
            <tr key={IdBombonas}>
              <td>
                <Link to={`/usina/bombona/edit/${IdBombonas}`}>
                  <i className="fas fa-pencil-alt"></i>
                </Link>
              </td>
              <td>{bombona}</td>
            </tr>
          ))}
        </Table>
        <div className={styles.loading}>
          <Loading display={showLoading ? 'block' : 'none'} />
        </div>
      </div>
    </Container>
  )
}
